import AsyncStorage from '@react-native-async-storage/async-storage';

export { AsyncStorage };

export async function getItem(key: string) {
  return AsyncStorage.getItem(key);
}

export async function setItem(key: string, value: string) {
  return AsyncStorage.setItem(key, value);
}

const CREATE_PLAN_PROMPT_TIMESTAMP_KEY = 'lastCreatePlanPromptTimestamp';

export async function setLastCreatePlanPromptTimestamp() {
  const now = new Date(Date.now());
  return await setItem(CREATE_PLAN_PROMPT_TIMESTAMP_KEY, now.toString());
}

export async function getLastCreatePlanPromptTimestamp() {
  const timestamp = await getItem(CREATE_PLAN_PROMPT_TIMESTAMP_KEY);
  if (timestamp) {
    return new Date(timestamp);
  }
}

export async function clearCache() {
  return AsyncStorage.clear();
}
